import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import store, { persistor } from './store'
import Theme from 'components/template/Theme'
import Layout from 'components/layout'
import history from './history'
import mockServer from './mock'
import appConfig from 'configs/app.config'
import './locales'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import PortalApp from './PortalApp'

const environment = process.env.NODE_ENV

const queryClient = new QueryClient()

/**
 * Set enableMock(Default false) to true at configs/app.config.js
 * If you wish to enable mock api
 */
if (environment !== 'production' && appConfig.enableMock) {
    mockServer({ environment })
}

// Detect subdomain
const getSubdomain = () => {
    const hostname = window.location.hostname
    const parts = hostname.split('.')

    // For localhost or IP addresses, return 'admin' as default
    if (
        hostname === 'localhost' ||
        hostname.startsWith('192.168') ||
        hostname.startsWith('127.0')
    ) {
        return 'admin'
    }

    // For subdomains like affiliates.maisonlyam.com
    if (parts.length >= 3) {
        return parts[0]
    }

    return 'admin'
}

function App() {
    const subdomain = getSubdomain()

    // Route to appropriate portal based on subdomain
    if (subdomain === 'affiliates') {
        return (
            <QueryClientProvider client={queryClient}>
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <PortalApp type="affiliate" />
                    </PersistGate>
                </Provider>
            </QueryClientProvider>
        )
    }

    if (subdomain === 'patients') {
        return (
            <QueryClientProvider client={queryClient}>
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <PortalApp type="patient" />
                    </PersistGate>
                </Provider>
            </QueryClientProvider>
        )
    }

    // Default admin portal
    return (
        <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <BrowserRouter>
                        <Theme>
                            <Layout />
                        </Theme>
                    </BrowserRouter>
                </PersistGate>
            </Provider>
        </QueryClientProvider>
    )
}

export default App
